import { render, staticRenderFns } from "./addorupdate.vue?vue&type=template&id=4f8be6fb&scoped=true"
import script from "./addorupdate.vue?vue&type=script&lang=js"
export * from "./addorupdate.vue?vue&type=script&lang=js"
import style0 from "./addorupdate.vue?vue&type=style&index=0&id=4f8be6fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8be6fb",
  null
  
)

export default component.exports